import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaLightbulb, FaUsers, FaClipboardList, FaRocket, FaPencilRuler, FaChartLine, FaCogs, FaCheckCircle } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaLightbulb size={80} color="var(--brand-primary)" />,
        title: "Product Vision Workshops",
        description: "Collaborative sessions to define your product vision, identify target users, and clarify business objectives. We help you articulate what success looks like and align stakeholders.",
    },
    {
        icon: <FaUsers size={80} color="var(--brand-primary)" />,
        title: "User Research & Validation",
        description: "Understand your users through interviews, surveys, and usability testing. We validate assumptions early to ensure you're building something people actually want and need.",
    },
    {
        icon: <FaClipboardList size={80} color="var(--brand-primary)" />,
        title: "Requirements Definition",
        description: "Document clear, actionable requirements with user stories, acceptance criteria, and technical specifications. We ensure everyone understands what needs to be built and why.",
    },
    {
        icon: <FaPencilRuler size={80} color="var(--brand-primary)" />,
        title: "Rapid Prototyping & Design",
        description: "Create interactive prototypes and wireframes to visualize your product before development. We iterate quickly based on feedback to refine the user experience.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Technical Feasibility Analysis",
        description: "Assess technical requirements, identify risks, and recommend the right technology stack. We ensure your MVP is technically sound and scalable from the start.",
    },
    {
        icon: <FaRocket size={80} color="var(--brand-primary)" />,
        title: "MVP Development",
        description: "Build production-ready MVPs in weeks, not months. We focus on core features that deliver value quickly, allowing you to test your hypothesis and gather real user feedback.",
    },
    {
        icon: <FaChartLine size={80} color="var(--brand-primary)" />,
        title: "Launch Strategy & Metrics",
        description: "Plan your go-to-market strategy and define success metrics. We help you launch effectively and measure what matters to validate product-market fit.",
    },
    {
        icon: <FaCheckCircle size={80} color="var(--brand-primary)" />,
        title: "Post-Launch Iteration",
        description: "Analyze user feedback and data to inform next steps. We help you prioritize features, fix issues, and iterate toward product-market fit based on real-world usage.",
    },
];

const ProductDiscoveryMVPDevelopment = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Product Discovery & MVP Development - Syrol Tech</title>
                <meta name="description" content="Structured discovery sessions to define product vision, requirements, and scope, enabling rapid delivery of production-ready MVPs in weeks, not months." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Product Discovery & MVP Development"
                pageName="Product Discovery & MVP Development"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Turn your idea into a production-ready MVP</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>Structured discovery sessions to define product vision, requirements, and scope, enabling rapid delivery of production-ready MVPs in weeks, not months.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our Product Discovery & MVP Development Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default ProductDiscoveryMVPDevelopment;
